import { Col, Form, Row, Select, Input,DatePicker } from "antd";
import { useEffect, useState } from "react";
import {
  GET_BUYER_ENDPOINT,
  GET_BUYING_OFFICE_ENDPOINT,
  SALES_CONTRACT_LIST,
  ALL_SALES_CONTRACT_LIST,
} from "../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../apiServices/common";

const TnaPlanFilterFields = ({ initialTableData }) => {
  const { Option } = Select;
  const [salseCotractList, setSalseCotractList] = useState([]);
  const [buyerList, setBuyerList] = useState([]);

  useEffect(() => {
    getSalseCotractList();
    getBuyerList();
  }, []);

  const getSalseCotractList = async () => {
    let res = await getData(ALL_SALES_CONTRACT_LIST);

    if (res) {
      setSalseCotractList(res?.data?.data || []);
    }
  };
  const getBuyerList = async (filterValues) => {
    const bodyData = {
      per_page: filterValues?.per_page || 1000,
      ...filterValues,
    };
    let response = await getData(GET_BUYER_ENDPOINT, false, bodyData);

    if (response && response?.data?.code === 200) {
      setBuyerList(response?.data?.data?.data || []);
    }
  };
  
  return (
    <>
      <Col span={4}>
        <Form.Item label="Sales Contract" name="sales_contract_id">
          <Select
            showSearch
            allowClear
            placeholder="Select a Sales Contract No"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            size="small"
          >
            {salseCotractList?.length &&
              salseCotractList.map((sup) => (
                <Option value={sup.id} key={sup.id}>
                  {sup.reference_no}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Buyer" name="buyer_id">
          <Select
            showSearch
            allowClear
            placeholder="Select a Buyer"
            onSearch={(value) => {
              getBuyerList({ name: value });
            }}
            optionFilterProp="children"
            size="small"
          >
            {buyerList?.length &&
              buyerList.map((sup) => (
                <Option value={sup.id} key={sup.id}>
                  {sup.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
    </>
  );
};

export default TnaPlanFilterFields;
